(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23972);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _seeds_data_role__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58386);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8080);
/* harmony import */ var components_dashboard_DashboardLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18148);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46648);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78470);
/* harmony import */ var types_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20411);










var Home = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (auth.isInitialized && auth.roles.length > 0) {
            // Handle Incident Management only plan. No menu items except incident management
            if (auth.subscription && auth.subscription !== "loading" && auth.subscription.items.find(function(item) {
                return item.product.name === types_api__WEBPACK_IMPORTED_MODULE_8__/* .STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME */ .uQ;
            })) {
                router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.INCIDENT_MANAGEMENT */ .Z.INCIDENT_MANAGEMENT);
                return;
            }
            if (auth.roles.length === 1) {
                switch(auth.roles[0].role_id){
                    case _seeds_data_role__WEBPACK_IMPORTED_MODULE_3__/* .ROLE_IDS[0] */ .$[0]:
                        router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.ADMIN_DASHBOARD */ .Z.ADMIN_DASHBOARD);
                        break;
                    case _seeds_data_role__WEBPACK_IMPORTED_MODULE_3__/* .ROLE_IDS[1] */ .$[1]:
                        router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.COACH_DASHBOARD */ .Z.COACH_DASHBOARD);
                        break;
                    case _seeds_data_role__WEBPACK_IMPORTED_MODULE_3__/* .ROLE_IDS[5] */ .$[5]:
                        router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.CLIENTS */ .Z.CLIENTS);
                        break;
                    default:
                        router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.DASHBOARD */ .Z.DASHBOARD);
                }
            } else {
                router.push(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROUTES.DASHBOARD */ .Z.DASHBOARD);
            }
        }
    }, [
        router,
        auth
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_DashboardLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        title: "Root",
        children: auth.isInitialized && auth.roles.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            children: "You do not have permission to view your dashboard. Please contact an administrator to resolve this issue."
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            open: true
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [964,6664,6359,1505,5578,7749,9806,8148,9774,2888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);